import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PiHandDepositFill } from "react-icons/pi";

import { Link } from "react-router-dom";
import {Modal, Button} from 'react-bootstrap';
import { PiHandWithdrawFill } from "react-icons/pi";

import whatsapp from "../assets/img/whatsapp.png";
import cointhumb from "../assets/img/cointhumb.png";
import ssl from "../assets/img/ssl.png";
import plus from "../assets/img/18-plus.png";
import glogo from "../assets/img/g-logo.png";
import gtlogo from "../assets/img/gt-logo.png";
import { v4 as uuidv4 } from "uuid";
import logo from "../assets/logo.webp";
import wchat from "../assets/img/w-chat.webp";
import dchat from "../assets/img/d-chat.webp";
import piggy from "../assets/img/piggy.svg";
import withdraw from "../assets/img/withdraw.svg";
import wchat1 from "../assets/img1/w-chat.png";
import dchat1 from "../assets/img1/d-chat.png";
import wallet from "../assets/img/walet.png";
import logouticon from "../assets/img/logoutt.png";
import girl from "../assets/img/girl.webp";
import profile from "../assets/img/profile.png";
import profileImage from "../assets/img/user.jpg";
import Swal from "sweetalert2";
import { BsChatRightDotsFill } from "react-icons/bs";


export default function Home() {
  let guestId = localStorage.getItem("guestId");
  const [data, setData] = useState(null); // State to store fetched data
  const [DatamarkUnseensettings, setDatamarkUnseensettings] = useState(null); // State to store fetched data
  const [isEditing, setIsEditing] = useState(false);
  const [user, setUser] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newUserName, setNewUserName] = useState(user.userName || "");

  const handleEditClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const userToken = localStorage.getItem("userToken");

    if (!userToken) {
      navigate("/");
    }
  }, []);

  const navigate = useNavigate();
  if (!guestId) {
    guestId = uuidv4(); // Generate a new UUID
  }
  const isAdmined = localStorage.getItem("isAdmin");
  const userTokened = localStorage.getItem("userToken");
  useEffect(() => {
  
    if (!userTokened  || !isAdmined === "false") {
      navigate("/");
      localStorage.clear();
    }
  }, [!isAdmined]);

  const logout = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Log Out",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate("/"); // Redirect to home after logout
      }
    });
  };

  const markUnseensettings = async () => {
    try {
      const response = await fetch(
        `https://api.Cash365days.in/admin/settings`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json(); // Convert response to JSON
      setDatamarkUnseensettings(result); // Store data in state
      console.log("Fetched Data:", result);
    } catch (error) {
      console.error("Error marking messages as seen:", error);
    }
  };
  const markUnseenMessagesAsSeen = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL_NODE}admin/links`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json(); // Convert response to JSON
      setData(result); // Store data in state
      console.log("Fetched Data:", result);
    } catch (error) {
      console.error("Error marking messages as seen:", error);
    }
  };
  useEffect(() => {
    markUnseenMessagesAsSeen();
    markUnseensettings();
  }, []);
  const [open, setOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [users, setUsers] = useState([]);
  const userid = localStorage.getItem("userid");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        // const response = await fetch(`${process.env.REACT_APP_API_URL_NODE}user/user-profile`, {
        const response = await fetch(`https://api.Cash365days.in/user/user-profile`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: userid }),
        });

        const data = await response.json();
        if (data.success === 1) {
          setUser(data.user);

          if (data.user.status === 0) {
            localStorage.clear();
            navigate("/");
          }
        }
      } catch (err) {
        setError("Failed to fetch user profile");
      } finally {
        setLoading(false);
      }
    };

    if (userid) {
      fetchUserProfile();
    }
  }, [userid, navigate, setUser, setError, setLoading]);

  const updateUserName = async () => {
    try {
      const response = await fetch(`https://api.Cash365days.in/update-username`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: userid, userName: newUserName }),
      });

      const data = await response.json();
      if (data.success === 1) {
        setUser({ ...user, userName: newUserName });
        setIsModalOpen(false);
      }
    } catch (err) {
      setError("Failed to update username");
    }
    }

  return (
    <section className="homepagesectiondesign">
      <div className="homepagedesign">
        <div className="container d-none d-md-block">
          <div className="d-flex justify-content-between align-items-center">
            <div className="withdarawchat">
              {/* <Link to="/Withdrawalchat" className="blinking-button"> */}
              {/* <Link to="/Withdrawalchat" className="blinking-button">
                <img src={wchat} alt="chat" width={"35px"} />
                <span>Withdraw Chat</span>
              </Link> */}
              <Link to="/DepositchatSocket" className="blinking-button">
                <img src={dchat} alt="chat" width={"35px"} />
                <span> Deposit Chat</span>
              </Link>
            </div>
            {/* <div className="logodesign gamelogo">
              {user.logo ? (
                <img
                  src={`https://api.Cash365days.in/uploads/${user.logo}`}
                  alt="Brand logo"
                />
              ) : (
                <img src={logo} alt="Default logo" />
              )}

            </div> */}
            <div className="depositchat">
              <div></div>
              {/* <Link to="/WithdrawPage" className="blinking-button new d-flex align-items-center"> */}
                {/* <div className="walletimage"> */}
                  {/* <img src={wallet} alt="chat" width="35px" /> */}
                  {/* <i class="bi bi-wallet"></i> */}
                {/* </div> */}
                {/* <img src={wallet} alt="chat" width={"35px"} /> */}
                {/* <span>Wallet <span className="d-block">{user.balance ? user.balance : 0}</span></span> */}
                {/* <span>Withdraw <span className="d-block"></span></span> */}
              {/* </Link> */}

              {/* <Link
                className="blinking-button"
                onClick={(e) => {
                  e.preventDefault();
                  logout(e);
                }}
              >
                <i class="bi bi-box-arrow-right mx-1"></i>
                <span>Logout</span>
              </Link> */}
              <div className="custom-dropdown">
                <div className="custom-profile-button" onClick={() => setOpen(!open)}>
                  <img src={profileImage} alt="Profile" className="custom-profile-img" />
                  <i className={`bi bi-chevron-down text-dark ${open ? "rotate" : ""}`}></i>

                </div>
                {open && (
                  <ul className="custom-dropdown-menu">
                    {/* <li className="custom-dropdown-item">
                      <span className="custom-icon">
                        <i className="bi bi-person-circle" size={16} />
                      </span>
                      <span onClick={handleEditClick} className="editable-text">
                        {user.userName}
                      </span>
                      <i className="bi bi-pencil edit-icon" size={14} onClick={handleEditClick} />
                    </li> */}
                    {/* <li className="custom-dropdown-item">
                      <span className="custom-icon">📞</span>
                      <span>{user.mobileNumber}</span>
                    </li> */}
                    <li className="custom-dropdown-item custom-logout" onClick={logout}>
                      <span className="custom-icon">🚪</span>
                      <span>Logout</span>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="Mobile_header d-md-none">
          <div className="float_btn">
            <div className="withdarawchat position-static">
              {/* <Link to="/Withdrawalchat" className="blinking-button w-chat">
                <img src={wchat1} alt="chat" width={"135px"} />
              </Link> */}
              <Link to="/DepositchatSocket" className="blinking-button d-chat">
                <img src={dchat1} alt="chat" width={"135px"} />
                {/* <span> Deposit Chat</span> */}
              </Link>
            </div>
          </div>

          <div className="mob-header">
            {/* <div className="depositchat">
              <Link to="/WithdrawPage" className="blinking-button wallet_btn">
                <div className="walletimage">
                  <i class="bi bi-wallet"></i>
                </div>
                <span className="balance_design">withdraw</span>
              </Link>
              <Link to="/DepositPage" className="blinking-button wallet_btn">
                <div className="walletimage">
                  <i class="bi bi-wallet"></i>
                </div>
                <span className="balance_design">deposit </span>
              </Link>
            </div> */}
            <div className="logodesign gamelogo">
              {/* <img src={logo} alt="Brand logo" /> */}
            </div>
            {/* <div className="depositchat">
              <Link
                className="blinking-button"
                onClick={(e) => {
                  e.preventDefault();
                  logout(e);
                }}
              >
                <img src={logouticon} alt="logout" />
                <span>Logout</span>
              </Link>
            </div> */}
            <div className="custom-dropdown">
              <div className="custom-profile-button" onClick={() => setOpen(!open)}>
                <img src={profileImage} alt="Profile" className="custom-profile-img" />
                <i className={`bi bi-chevron-down text-dark ${open ? "rotate" : ""}`}></i>

              </div>
              {open && (
                <ul className="custom-dropdown-menu">
                  {/* <li className="custom-dropdown-item">
                    <span className="custom-icon">
                      <i className="bi bi-person-circle" size={16} />
                    </span>
                    <span onClick={handleEditClick} className="editable-text">
                      {user.userName}
                    </span>
                    <i className="bi bi-pencil edit-icon" size={14} onClick={handleEditClick} />
                  </li> */}
                  {/* <li className="custom-dropdown-item">
                    <span className="custom-icon">📞</span>
                    <span>{user.mobileNumber}</span>
                  </li> */}
                  <li className="custom-dropdown-item custom-logout" onClick={logout}>
                    <span className="custom-icon">🚪</span>
                    <span>Logout</span>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>

      <section className="banner">
      {/* <div className="withdrawchatnew">
              <Link to="/WithdrawPage" className="blinking-button d-flex wallet_btn">
              <div className="walletimagenew">
                <PiHandDepositFill/>
                </div>
                <span className="balancewith">withdraw</span>
              </Link>
            </div> */}
           
        <div className="container">
            <div className="depositchatnew">
           <Link to="/DepositPage" className="blinking-button d-flex wallet_btn">
               <div className="walletimagenew">
               <PiHandWithdrawFill/>
               </div>
               <span className="balancewith">Deposit</span>

             </Link>
           </div>
          <div className="banner_outer">
            {/* <div className="left_part">
              <img src={girl} alt="girl" />
            </div> */}
            <div className="right_part text-center">
              <h1>
                Welcome 
              </h1>
              <p>IF YOU WANT TO BE A WINNER THEN BE FEARLESS</p>
              <div className="Bonus_btn_outer">
                {/* <a
                  href={`https://wa.me/+91${DatamarkUnseensettings && DatamarkUnseensettings.whatsapp_no
                    }?text=`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="Bonus_btn"
                >
                  5% Bonus on New Id
                </a> */}
                <a
                  href={`https://wa.me/+${DatamarkUnseensettings && DatamarkUnseensettings.whatsapp_support
                    }?text=`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="Whatsapp_btn"
                >
                  Whatsapp support
                  <span>
                    <img src={whatsapp} alt="whatsapp" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="Bonus_box">
        <div className="container-fluid">
          <div className="Bonus_box_outer">
            <div className="Bonus_list">
              <span className="Bonus_list_icon">
                <img src="assets/img/Bonus-list-icon-1.png" alt="" />
              </span>
              <div className="Bonus_list_heading">
                <h3>2 Lacs+</h3>
                <span>Players</span>
              </div>
            </div>
            <div className="Bonus_list">
              <span className="Bonus_list_icon">
                <img src="assets/img//Bonus-list-icon-2.png" alt="" />
              </span>
              <div className="Bonus_list_heading">
                <h3>850+</h3>
                <span>Games Available</span>
              </div>
            </div>
            <div className="Bonus_list">
              <span className="Bonus_list_icon">
                <img src="assets/img//Bonus-list-icon-3.png" alt="" />
              </span>
              <div className="Bonus_list_heading">
                <h3>12+</h3>
                <span>Exchange ID'S</span>
              </div>
            </div>
          </div>
           <div className="Bonus_limit">
            <span>
              5% <b>Bonus</b>
            </span>
          </div>
          <div className="new_id">
            <span> on New Id</span>
          </div> 
        </div>
      </section> */}

      <section className="Sites_Available mb-0">
        <div className="container">
          {/* <div className="Sites_Available_heading">
            <h2>All Premium Sites Available</h2>
          </div> */}
          <div className="Sites_Available_outer">
            <ul>
              {data &&
                data.map((item, index) => (
                  <li key={index}>
                    <div className="Sites_Available_list">
                      <div className="side_logo">
                        <img
                          src={`https://api.Cash365days.in/uploads/${item.logo}`}
                          alt="Site Logo"
                        />
                        {/* <img src={`${process.env.REACT_APP_API_URL_NODE}uploads/${item.logo}`} alt="Site Logo" /> */}
                        {/* <img src="assets/img//site-logo-2.png" alt="" /> */}
                      </div>
                      <div className="Username">
                        <span>
                          Username : {item.userName} Passward : {item.password}
                        </span>
                      </div>
                      <div className="sitelink">
                        <span>Link :</span>{" "}
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.link}
                        </a>{" "}
                      </div>

                      <div className="coin">
                        <p>(1 Coin = 1 Rs)</p>
                        <p>(Minimum Id: {item.min_id} Rs)</p>
                        <p>(Minimum Bet: {item.min_bet} Rs)</p>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </section>

      <Modal show={isModalOpen} onHide={handleClose} centered  className="modelcolornew ">
        <Modal.Header closeButton>
          <Modal.Title>Edit Username</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="edit usename" className="text-dark">Edit Username</label>
          <input
            type="text"
            value={newUserName}
            onChange={(e) => setNewUserName(e.target.value)}
            className="form-control"
          />
        </Modal.Body>
        <Modal.Footer>
                <div className="d-flex gap-2 justify-content-end align-items-center">
             <div>
             <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
             </div>
             <div>
             <Button variant="primary" onClick={updateUserName}>
            Save Changes
          </Button>
             </div>
             
          
                </div>
        </Modal.Footer>
      </Modal>

      <footer className="footer">
        <div className="container">
          <div className="Disclaimer">
            <ul>
              <li>
                <Link to={"/Privacy"}>Privacy Policy</Link>
              </li>
              <li>
                <Link to={"/Disclaimer"}>Disclaimer </Link>
              </li>
            </ul>
          </div>
          {/* <div className="ssl_head">
            <img src={ssl} alt="" />
            <div className="ssl_heading">
              <span>100% SAFE</span>
              <p>Protected connection and encrypted data.</p>
            </div>
          </div> */}
          <div className="License">
            {/* <p>
              The website is operated and registered in Curaçao under License
              No. 7048/JAZ. The registered address is E-Commerce Park
              Heelsumstraat 51, Willemstad, Curacao. All transactions are
              processed by the entity that owns and operates the website
            </p> */}
            {/* <div>
              <div className="License_logos">
                <span>
                  <img src={plus} alt="" />
                </span>
                <span>
                  <img src={glogo} alt="" />
                </span>
                <span>
                  <img src={gtlogo} alt="" />
                </span>
              </div>
              <div className="stop-logo">
                <span>
                  <img src="images/ball-logo.png" alt="" />
                </span>
                <span>
                  <img src="images/gam-stop-logo.png" alt="" />
                </span>
              </div>
            </div> */}
          </div>
          <div className="copyright">
            <span>Copyright © 2026 All right reserved.</span>
          </div>
        </div>
      </footer>
     
    </section>
  );
}
